import { Card, CardBody, CardHeader } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';

export function ControlGroupCard({
  title,
  dataGroupScope,
  children,
}: PropsWithChildren<{ title?: string; dataGroupScope: string }>) {
  return (
    <Card variant="outline" role="group" data-group-scope={dataGroupScope}>
      {title && (
        <CardHeader pt={2} pb={2} fontWeight="bold" as="h3">
          {title}
        </CardHeader>
      )}

      <CardBody pt={2} gap={4} display="flex" flexDirection="column">
        {children}
      </CardBody>
    </Card>
  );
}
